import styled from "styled-components"

export const FrameWrapper = styled.div`
  height: 100vh;
  position: relative;
  padding-top: 2em;
`
